import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/esnext.global-this.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { LocationOnOutlined, KeyboardArrowDownOutlined, Close, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { Container, AppBar, Grid, TAGLink, Icon, Box, Popper, TAGTypography, TAGOutlinedButton, TAGSvgIcon, useMediaQuery, Divider, IconButton } from '../../../..';

var Location = function Location(_ref) {
  var applicationName = _ref.applicationName,
      isLargeDevice = _ref.isLargeDevice,
      locationBarData = _ref.locationBarData,
      officeInfo = _ref.officeInfo;

  var _useState = useState({
    anchorEl: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var isSmallDevice = useMediaQuery('(max-width: 1024px)');
  useEffect(function () {
    window.addEventListener('scroll', setAnchorEl);
    return function () {
      window.removeEventListener('scroll', setAnchorEl);
    };
  });

  function setAnchorEl() {
    if (scrollY) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        anchorEl: null
      }));
    }
  }

  function handleClick(e) {
    e.preventDefault();
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorEl: state.anchorEl ? null : e.currentTarget
    }));
    window.removeEventListener('scroll', setAnchorEl);
  }

  function handleClose() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorEl: null
    }));
  }

  var OfficeInformationBlock = function OfficeInformationBlock(_ref2) {
    var _officeInfo$address, _officeInfo$address2, _officeInfo$address3;

    var officeInfo = _ref2.officeInfo;
    return React.createElement(React.Fragment, null, React.createElement(Grid, {
      item: true
    }, React.createElement(TAGTypography, {
      variant: "h2",
      fontStyle: "bodyLargeSemiBold",
      color: "primary",
      sx: {
        display: 'flex'
      }
    }, officeInfo.name)), React.createElement(Grid, {
      item: true
    }, ((_officeInfo$address = officeInfo.address) === null || _officeInfo$address === void 0 ? void 0 : _officeInfo$address.line1) && React.createElement(TAGTypography, {
      variant: "bodySmallBook",
      color: "primary",
      sx: {
        display: 'flex'
      }
    }, officeInfo.address.line1), ((_officeInfo$address2 = officeInfo.address) === null || _officeInfo$address2 === void 0 ? void 0 : _officeInfo$address2.line2) && React.createElement(TAGTypography, {
      variant: "bodySmallBook",
      color: "primary",
      sx: {
        display: 'flex'
      }
    }, officeInfo.address.line2), ((_officeInfo$address3 = officeInfo.address) === null || _officeInfo$address3 === void 0 ? void 0 : _officeInfo$address3.line3) && React.createElement(TAGTypography, {
      variant: "bodySmallBook",
      color: "primary",
      sx: {
        display: 'flex'
      }
    }, officeInfo.address.line3), React.createElement(TAGTypography, {
      variant: "bodySmallBook",
      color: "primary",
      sx: {
        display: 'flex'
      }
    }, officeInfo.name, " ", officeInfo.address.zipCode), officeInfo.distance && React.createElement(TAGTypography, {
      variant: "bodySmallBook",
      color: "text.tertiary",
      sx: {
        display: 'flex'
      }
    }, "".concat(officeInfo.distance, " mi"))));
  };

  var ODPLinksBlock = function ODPLinksBlock(_ref3) {
    var _address$state, _address$city, _address$line, _globalThis$location;

    var isSmallDevice = _ref3.isSmallDevice,
        officeInfo = _ref3.officeInfo;
    var address = officeInfo === null || officeInfo === void 0 ? void 0 : officeInfo.address;
    var facilityState = address === null || address === void 0 ? void 0 : (_address$state = address.state) === null || _address$state === void 0 ? void 0 : _address$state.toLowerCase();
    var city = address === null || address === void 0 ? void 0 : (_address$city = address.city) === null || _address$city === void 0 ? void 0 : _address$city.split(' ').join('-').toLowerCase();
    var location = (_address$line = address.line1) === null || _address$line === void 0 ? void 0 : _address$line.split(' ').join('-').toLowerCase().replace(/[,\.]/gi, '');
    var odpUrl = ((_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.origin) && "".concat(globalThis.location.origin, "/dentist/").concat(facilityState, "/").concat(city, "/").concat(location);
    var ODPLinks = [{
      id: 1,
      path: odpUrl,
      title: 'Office Details'
    }, {
      id: 2,
      path: "".concat(odpUrl, "#dentists"),
      title: 'Dentists'
    }, {
      id: 3,
      path: "".concat(odpUrl, "#our-services"),
      title: 'Services'
    }, {
      id: 4,
      path: "".concat(odpUrl, "#pricing"),
      title: 'Pricing'
    }, {
      id: 5,
      path: "".concat(odpUrl, "#insurance-financing"),
      title: 'Insurance & financing'
    }];
    return React.createElement(React.Fragment, null, ODPLinks.map(function (item) {
      return React.createElement(React.Fragment, null, React.createElement(Grid, {
        item: true,
        key: item.title
      }, React.createElement(TAGLink, {
        variant: "bodyLargeSemiBold",
        href: item.path,
        sx: {
          '> span': {
            display: 'flex',
            padding: isSmallDevice ? '17px 20px 18px' : '17px 20px 18px 0'
          }
        },
        color: "secondary.main"
      }, item.title)), isSmallDevice && React.createElement(Grid, {
        item: true,
        key: "divider-".concat(item.id)
      }, React.createElement(Divider, null)));
    }));
  };

  var FindOfficeButton = function FindOfficeButton(_ref4) {
    var locationBarData = _ref4.locationBarData;
    return React.createElement(TAGOutlinedButton, {
      href: locationBarData.locationBarFindOfficeUrl,
      sx: {
        textTransform: 'uppercase',
        width: '100%'
      }
    }, React.createElement(TAGTypography, {
      variant: "bodySmallSemiBold",
      sx: {
        letterSpacing: '1px',
        display: 'flex'
      }
    }, "Find another office"));
  };

  return React.createElement(AppBar, {
    position: "sticky",
    sx: {
      backgroundColor: 'backgrounds.light',
      height: 40,
      top: isLargeDevice ? 88 : 64,
      marginBottom: '15px',
      boxShadow: 'none',
      display: isSmallDevice ? 'inline-table' : 'block'
    }
  }, React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center",
    spacing: 1,
    sx: {
      marginTop: 0
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, {
    color: "primary"
  }, React.createElement(LocationOnOutlined, null))), officeInfo.name ? React.createElement(React.Fragment, null, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: "primary"
  }, locationBarData.locationBarWithOfficeTitle)), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    onClick: handleClick,
    sx: {
      justifyContent: 'center',
      '> span': {
        display: 'flex'
      }
    },
    variant: "bodyMediumBold",
    color: "primary"
  }, React.createElement(React.Fragment, null, officeInfo.name, React.createElement(Icon, {
    color: "primary"
  }, state.anchorEl ? React.createElement(KeyboardArrowUpOutlined, null) : React.createElement(KeyboardArrowDownOutlined, null)))))) : React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: locationBarData.locationBarFindOfficeUrl
  }, locationBarData.locationBarWithOutOfficeTitle))), React.createElement(Popper, {
    open: !isSmallDevice && Boolean(state.anchorEl),
    anchorEl: state.anchorEl
  }, React.createElement(Box, {
    sx: {
      borderRadius: '8px',
      padding: '10px 30px',
      backgroundColor: 'backgrounds.white',
      border: '1px solid',
      borderColor: 'neutrals.disabled',
      minWidth: '600px',
      boxShadow: '0 15px 12px rgb(0 0 0 / 22%), 0 19px 38px rgb(0 0 0 / 30%)'
    }
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: "15px"
  }, React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: "flex-end"
  }, React.createElement(IconButton, {
    onClick: handleClose,
    sx: {
      padding: 0
    }
  }, React.createElement(Icon, {
    color: "primary"
  }, React.createElement(Close, null)))), React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center",
    justifyContent: "flex-start"
  }, React.createElement(Grid, {
    item: true,
    xs: 2
  }, React.createElement(TAGSvgIcon, {
    icon: "DentalOffice",
    size: 70
  })), React.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    spacing: 2,
    xs: 5,
    wrap: "nowrap"
  }, React.createElement(OfficeInformationBlock, {
    officeInfo: officeInfo
  })), React.createElement(Grid, {
    item: true,
    xs: 5
  }, React.createElement(FindOfficeButton, {
    locationBarData: locationBarData
  }))), React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: "space-between",
    alignItems: "center"
  }, applicationName !== 'AspenDental - Office Details' && React.createElement(ODPLinksBlock, {
    isSmallDevice: false,
    officeInfo: officeInfo
  })))))), isSmallDevice && Boolean(state.anchorEl) && React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: {
      backgroundColor: 'backgrounds.white',
      marginTop: '4px'
    },
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: "space-evenly",
    alignItems: "center",
    direction: "row-reverse",
    sx: {
      marginBottom: '20px'
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGSvgIcon, {
    icon: "DentalOffice",
    size: 70
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    spacing: 2
  }, React.createElement(OfficeInformationBlock, {
    officeInfo: officeInfo
  })))), applicationName !== 'AspenDental - Office Details' && React.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "stretch"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Divider, null)), React.createElement(ODPLinksBlock, {
    isSmallDevice: true,
    officeInfo: officeInfo
  })), React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: "center",
    alignItems: "center",
    sx: {
      padding: '20px 0'
    }
  }, React.createElement(Grid, {
    item: true,
    xs: 10,
    md: 6
  }, React.createElement(FindOfficeButton, {
    locationBarData: locationBarData
  }))), React.createElement(Divider, null)));
};

export default Location;